<div class="container-fluid" [@fadeInAnimation]>
  <div class="row">
    <div class="col-xl-3 col-lg-2"></div>
    <div class="col-xl-6 col-lg-8">
      <div class="jumbotron">
        <div class="garanti-xl-logo text-center">
          <img [src]="isBorgenarMode ? 'assets/img/borgenarsportal-logo.png' : 'assets/img/garanti-portal-logo.png'" />
        </div>
        <div class="frontpage-text lead">
          <span [innerHTML]="(isBorgenarMode ? 'home.brodtext-borgenar' : 'home.brodtext') | translate | safehtml"></span>
        </div>
        <hr />
        <div class="row">
          <div class="col-md-3 col-lg-2"></div>
          <div class="col-md-6 col-lg-8">
            @if (!isLoggedIn) {
              <a routerLink="/login" class="btn-garanti btn-pink w-100 hide-l mb-0">
                <fa-icon [icon]="['fas', 'sign-in-alt']" [fixedWidth]="true" class="me-2"></fa-icon>{{ 'navbar.logga-in' | translate }}
              </a>
            }
            <a routerLink="/more-info" class="btn-garanti btn-pink w-100 mt-2 mb-0">
              <fa-icon [icon]="['fas', 'info']" [fixedWidth]="true" class="me-2"></fa-icon>{{ (isBorgenarMode ? 'navbar.las-mer-borgenar' : 'navbar.las-mer') | translate }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
